import React, { useState, useEffect } from 'react'
import { withRouter } from "react-router-dom";
import { globalGetService, globalExportService } from '../../../utils/globalApiServices';
import { Grid, Table, TableCell, TableHead, TableRow, TableBody, Paper, TableSortLabel } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { useSnackbar } from 'notistack';
import { downloadFileType, Comma_format } from '../../../utils';
import { EmptyCollection, PageLoader } from '../../../shared_elements';
import Pagination from '../../../shared_elements/components/Pagination';
import FilterComponent from '../../../shared_elements/components/filter_component';
import ExportMenu from '../../../shared_elements/components/ExportMenu';
import { smbcInstance } from '../../../shared_elements/components';

const LimiterDue = () => {
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeltonLoader, setSkeltonLoader] = useState(false);
    const [llpData, setLLPData] = useState({ data: [], pagination: {} });
    const [filter, setFilter] = useState({});
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });

    useEffect(() => {
        smbcChartLLPLimiter({ per_page: 250 });
    }, []);

    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' };
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' };
        }
        setSortInfo(sortQuery);
        smbcChartLLPLimiter({ ...filter, ...sortQuery, page: 1, per_page: llpData?.data?.pagination?.per_page }, 'pageLoader');
    };

    const smbcChartLLPLimiter = (query, loader) => {
        loader === "pageLoader" ? setLoading(true) : setSkeltonLoader(true);
        globalGetService(smbcInstance ? `camo/smbc_dashboard/limiter/` : `camo/dashboard/limiter/`, { ...query })
            .then((response) => {
                setLLPData(response.data);
                setFilter(query);
                loader === "pageLoader" ? setLoading(false) : setSkeltonLoader(false);
            })
            .catch((error) => {
                console.error('Error fetching chart data:', error);
                setLoading(false);
                setSkeltonLoader(false);
            });
    };

    const exportLimiter = (extension) => {
        setLoading(true);
        const queryParams = sortInfo?.sort === '' && sortInfo?.sort_by === ''
            ? Object.assign({}, filter)
            : Object.assign({}, filter, sortInfo);
        globalExportService(`camo/smbc_dashboard/limiter/`, { ...queryParams, download: extension })
            .then(response => {
                setLoading(false);
                enqueueSnackbar("Download of Limiter Due List successfull", { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                downloadFileType(response.data, `Limiter Due_List`, extension);
            });
    };

    const FilterOptions = {
        'gte': { inputType: 'number', title: 'Value From' },
        'lte': { inputType: 'number', title: 'Value To' },
    };

    const rowClick = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        return smbcInstance
            ? window.open(`${item?.id}/${item?.asset_type}/op_history/list`, '_blank')
            : window.open(`${item?.id}/${item?.asset_type}/ad/list`, '_blank');
    };

    const filterObj = Object.assign({}, filter, delete filter?.page, delete filter?.sort, delete filter?.sort_by, delete filter?.per_page);
    const filterOptions = Object.assign({}, FilterOptions);

    const sortLabel = (key) => (
        <TableSortLabel
            active={sortInfo.sort === key}
            direction={sortInfo.sort === key ? sortInfo.sort_by : 'asc'}
            onClick={() => createSortHandler(key)}
            className="col-align-center"
        />
    );

    return (
        <>
            {skeltonLoader ? (
                <Skeleton variant="rect" animation="wave" height={400} />
            ) : (
                <>
                    <Paper square className="dashboard-chart">
                        <div className="dashboard-chart-title">
                            <Grid container spacing={0} alignItems="center">
                                <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <ul className="list-inline limiter-left" style={{ margin: 0 }}>
                                        <li className="list-inline-item limiter-title-item">
                                            <h5>Limiter Due</h5>
                                        </li>
                                        <li className="list-inline-item">
                                            <FilterComponent
                                                filter={filterObj}
                                                filterMenu={filterOptions}
                                                getResponseBack={(applyFilter) => smbcChartLLPLimiter({ ...applyFilter, per_page: 250 }, 'pageLoader')}
                                            />
                                        </li>
                                    </ul>
                                    <ExportMenu
                                        exportReportFn={(file) => exportLimiter(file.extension)}
                                        files={[{ title: 'EXCEL', extension: 'xlsx' }]}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </Paper>
                    <Paper className="major-assemblies-list" square>
                        <div
                            className="limiter-table-scroll"
                            style={{ height: !llpData?.data?.results?.length ? "0px" : "408px" }}
                        >
                            <Table className="mui-table-format" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <TableSortLabel active={sortInfo.sort === 'engine_type'} direction={sortInfo.sort === 'engine_type' ? sortInfo.sort_by : 'asc'} onClick={() => createSortHandler('engine_type')} className="col-align-center">
                                                Engine
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel active={sortInfo.sort === 'esn'} direction={sortInfo.sort === 'esn' ? sortInfo.sort_by : 'asc'} onClick={() => createSortHandler('esn')} className="col-align-center">
                                                ESN
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel active={sortInfo.sort === 'lessee'} direction={sortInfo.sort === 'lessee' ? sortInfo.sort_by : 'asc'} onClick={() => createSortHandler('lessee')} className="col-align-center">
                                                Lessee
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel active={sortInfo.sort === 'operator'} direction={sortInfo.sort === 'operator' ? sortInfo.sort_by : 'asc'} onClick={() => createSortHandler('operator')} className="col-align-center">
                                                Operator
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell className="limiter-type-cell">
                                            <TableSortLabel active={sortInfo.sort === 'limiter_type'} direction={sortInfo.sort === 'limiter_type' ? sortInfo.sort_by : 'asc'} onClick={() => createSortHandler('limiter_type')} className="col-align-center">
                                                Limiter Type
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel active={sortInfo.sort === 'value'} direction={sortInfo.sort === 'value' ? sortInfo.sort_by : 'asc'} onClick={() => createSortHandler('value')} className="col-align-center">
                                                Value
                                            </TableSortLabel>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {llpData?.data?.results?.map((item, index) => (
                                        <TableRow key={index} className="cursor-pointer" onClick={(e) => rowClick(e, item)}>
                                            <TableCell>{item?.engine_type || "--"}</TableCell>
                                            <TableCell>{item?.esn || "--"}</TableCell>
                                            <TableCell>{item?.lessee || "--"}</TableCell>
                                            <TableCell>{item?.operator || "--"}</TableCell>
                                            <TableCell>{item?.limiter_type || "--"}</TableCell>
                                            <TableCell>{item.value ? Comma_format(parseInt(item.value)) : item.value === null ? 'N/A' : 0}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                        <Pagination
                            pagination={llpData?.data?.pagination}
                            onChangePage={(event, newPage) => smbcChartLLPLimiter({ ...filter, page: newPage + 1, per_page: llpData?.data?.pagination?.per_page }, 'pageLoader')}
                            onChangeRowsPerPage={(event) => smbcChartLLPLimiter({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                        />
                        {!llpData?.data?.results?.length && (
                            <div className="empty-center">
                                <EmptyCollection title="No records found" />
                            </div>
                        )}
                    </Paper>
                </>
            )}
            {isLoading && <PageLoader />}
        </>
    );
};

export default withRouter(LimiterDue);
